import { styled } from "@mui/material/styles";

export default styled("span")(({ theme, ownerState }) => {
  const { checked, color, size, disabled } = ownerState;
  const palette = theme.palette;
  const activeColor = palette[color]?.main ?? palette.success.main;
  const width = size === "medium" ? 44 : 36;
  const height = size === "medium" ? 24 : 20;
  const thumbSize = size === "medium" ? 20 : 16;
  const gap = 2;
  const travel = width - thumbSize - gap * 2;

  return {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    width,
    minWidth: width,
    height,
    borderRadius: height,
    padding: gap,
    backgroundColor: checked ? activeColor : palette.grey[300],
    opacity: disabled ? 0.45 : 1,
    transition: "background-color 0.2s ease",
    verticalAlign: "middle",
    flexShrink: 0,

    "& input": {
      position: "absolute",
      inset: 0,
      opacity: 0,
      width: "100%",
      height: "100%",
      margin: 0,
      cursor: disabled ? "not-allowed" : "pointer",
      zIndex: 1,
    },

    "&:has(input:focus-visible)": {
      boxShadow: `0 0 0 2px ${palette.common.white}, 0 0 0 4px ${activeColor}`,
    },

    "& .soft-switch-thumb": {
      width: thumbSize,
      height: thumbSize,
      borderRadius: "50%",
      backgroundColor: palette.common.white,
      boxShadow: "0 1px 3px rgba(0,0,0,0.22)",
      transform: checked ? `translateX(${travel}px)` : "translateX(0)",
      transition: "transform 0.2s ease",
      pointerEvents: "none",
    },
  };
});
